<template>
  <div class="page c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="top-spacing container-history colum">
      <div
        v-for="(item, index) in dataHistory"
        :key="index"
        class="box-recharge mb-20"
      >
        <div style="border-bottom: 1px solid #cac7c7">
          <div
            class="flex align-items-center justify-content-space-between px-15 mb-5"
          >
            <span class="fw-600 c-tiny">
              {{ formatDate(item.created_at) }}
            </span>
            <span
              @click="copyText(item.transaction_code)"
              class="fw-600 c-inherit-text c-tiny cursor-pointer"
            >
              {{ item.transaction_code }}
              <img class="ml-5" :src="icons.IconCopy" alt="" />
            </span>
          </div>
        </div>
        <div class="px-15 mb-5 mt-10 flex justify-content-space-between">
          <div>
            <span style="color: #999999;" class="c-caption lf-18">{{
              $t("wap.text69")
            }}</span>
            <h2
              class="fw-600 c-title2"
              :style="{
                color: item.type === 1 ? bg.c_inherit_text : '#FF0000'
              }"
              style="margin:0"
            >
              {{ `${item.type === 1 ? "+" : "-"}` + formatNumber(item.point) }}
            </h2>
          </div>
          <div>
            <span style="color: #999999;" class="c-caption lf-18">{{
              $t("wap.text70")
            }}</span>
            <h2 class="fw-600 c-black c-title2" style="margin:0">
              {{ formatNumber(item.point_balance) }}
            </h2>
          </div>
        </div>
        <div class="px-15">
          <div>
            <span style="color: #999999;" class="c-caption lf-18">{{
              $t("wap.text71")
            }}</span>
            <p
              v-html="item.description"
              class="c-tiny fw-500"
              style="margin: 0; padding:0"
            ></p>
          </div>
        </div>
      </div>
    </div>
    <div ref="end-location" />
    <infinite-loading
      ref="infiniteLoading"
      :identifier="infiniteId"
      @infinite="infiniteHandler"
    >
      <div slot="no-more">{{ $t("wap.text72") }}</div>
      <div slot="no-results">{{ $t("wap.text73") }}</div>
    </infinite-loading>
  </div>
</template>

<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import IconPointWallet from "@/assets/img/iconV2/icon-point-wallet.svg";
import IconMoney from "@/assets/img/iconV2/icon-money-gold.svg";
import IconCopy from "@/assets/img/iconV2/copy.svg";
import PointResource from "@/views/api/point";
import { formatNumber } from "@/plugins/init";
import { getToken } from "@/utils/auth";
import { getBackGround } from "@/utils/wapAuth";

const moment = require("moment");

export default {
  name: "ListHistoryTransaction",
  components: {
    MainNavBarWapV2
  },
  methods: {
    copyText(val) {
      const input = document.createElement("input");
      input.value = val;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success(this.$t("wap.text127"));
    },
    formatNumber,
    handleResize() {
      if (window.innerWidth < 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      console.log("is mobile", this.isMobile);
    },
    formatDate(timeString) {
      const formattedDateTime = moment(
        timeString,
        "HH:mm:ss,DD-MM-YYYY"
      ).format("DD/MM/YYYY - hh:mm A");
      return formattedDateTime;
    },
    async infiniteHandler($state) {
      console.log("$state_________", $state);
      if (!this.teeTimeLoading) {
        this.query.page += 1;
        this.teeTimeLoading = true;

        const {
          error_code,
          data
        } = await PointResource.get_history_point_bonus({
          uid: getToken().vga,
          ...this.query
        });
        this.teeTimeLoading = false;

        if (error_code === 0) {
          const newPosition =
            this.$refs["end-location"].getBoundingClientRect().top +
            window.pageYOffset;

          if (this.position) window.scrollTo(0, this.position);

          this.position = newPosition;
          this.dataHistory = [...this.dataHistory, ...data];
          console.log("dataHistory......", this.dataHistory);
        }
        if (data.length < 10) {
          $state.complete();
        } else {
          $state.loaded();
        }
      }
    },
    onGetList() {
      this.infiniteId += 1;
      this.loadingData = true;
      PointResource.get_history_point_bonus({
        uid: getToken().id,
        ...this.query
      }) //552
        .then(res => {
          console.log("res___________", res);
          if (res.error_code !== 0) {
            this.$message.error(res.error_msg);
            return;
          }
          this.dataHistory = res.data || [];
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    onLoadCertificate(insurrance_id) {
      console.log("load certificate", insurrance_id);
      this.$router.push({
        name: "wap-certificate-insurance",
        params: { insurrance_id: insurrance_id }
      });
    },

    handleBack() {
      this.$router.push({ path: "/wap" });
    }
  },
  computed: {
    resizeClass() {
      return {
        mobile: this.isMobile,
        desktop: !this.isMobile
      };
    }
  },
  watch: {
    typeInsurance(val) {
      console.log("typeInsurance", val);
    }
  },
  created() {
    // this.onGetList();
  },
  mounted() {
    this.defaultBackgroundColor = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "#F0F1F5";
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    document.body.style.backgroundColor =
      this.defaultBackgroundColor == "" ? "white" : this.defaultBackgroundColor;
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      bg: getBackGround(),
      teeTimeLoading: false,
      position: 0,
      loadingData: false,
      infiniteId: +new Date(),
      dataHistory: [],
      defaultBackgroundColor: "",
      dialogVisible: false,
      isMobile: false,
      isActive: 0,
      infoHeader: {
        title: this.$t("wap.text128"),
        isShowHomeIcon: false
      },
      query: { page: 0 },
      icons: {
        IconPointWallet,
        IconMoney,
        IconCopy
      }
    };
  }
};
</script>

<style scoped>
.container-history {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  max-width: 900px;
}
.top-spacing {
  padding-top: 100px;
}
.option-recharge {
  padding-left: -10px;
  margin-left: -10px;
}
.btn-option-recharge {
  padding: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
  border-radius: 100px;
  font-size: 12px;
  border: 1px solid #cac7c7;
}
.box-recharge {
  background: #ffff;
  min-height: 147px;
  box-shadow: 0px 2px 4px 0px #00000033;
  border-radius: 10px;
  padding: 10px 0;
}
.page {
  min-height: 100vh;
  padding: 0px 20px;
}
hr {
  border: none;
  border-top: 1.5px dotted #e2e2e2;
  color: #fff;
  margin: 8px 0px;
  background-color: #fff;
  height: 4px;
  width: 100%;
}

.icon-list {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

p {
  margin: 2px 0px;
  font-size: medium;
  font-weight: 500;
}

.mobile {
  display: block;
}
.desktop {
  display: none;
}

::v-deep :focus {
  box-shadow: none !important;
}
.popper-text {
  font-size: small !important;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 75px;
  }
}
</style>

<style>
.popper-class {
  width: 90% !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  color: black !important;
}
</style>
